import { render, staticRenderFns } from "./budget-instagram-ads-combien-investir-pour-obtenir-des-resultats-concrets.vue?vue&type=template&id=5432d6e8&"
import script from "./budget-instagram-ads-combien-investir-pour-obtenir-des-resultats-concrets.vue?vue&type=script&lang=js&"
export * from "./budget-instagram-ads-combien-investir-pour-obtenir-des-resultats-concrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports